/**
 * SpecificAI model tab override modes (Figma Model Configuration).
 *
 * Each section (System Prompt / User Prompt / Output format) is a tri-state:
 * - "same"      — inherit the commercial (teacher) value; persisted as `null`.
 * - "disable"   — explicitly none is sent; persisted as `""`.
 * - "customize" — an explicit override; persisted as the override text.
 */

export const OVERRIDE_MODES = {
    same: 'same',
    disable: 'disable',
    customize: 'customize',
};

export const OVERRIDE_FIELD_KEYS = ['systemPrompt', 'userPrompt', 'schema'];

export const overrideModeFromValue = (value) => {
    if (value == null) return OVERRIDE_MODES.same;
    if (String(value).trim() === '') return OVERRIDE_MODES.disable;
    return OVERRIDE_MODES.customize;
};

export const overrideValueForMode = (mode, { teacherValue = '', currentValue = null } = {}) => {
    if (mode === OVERRIDE_MODES.same) return null;
    if (mode === OVERRIDE_MODES.disable) return '';
    // Customize: keep the existing custom text when switching back, otherwise
    // prefill from the inherited commercial value so editing starts from it.
    if (currentValue != null && String(currentValue).trim() !== '') return currentValue;
    return teacherValue || '';
};

/**
 * Badge text next to the "SpecificAI model" tab summarizing how the student
 * setup differs from the commercial one ("Same as commercial" /
 * "N different from commercial" / "All different from commercial").
 */
export const specificAIDiffBadge = (overrides) => {
    const differentCount = OVERRIDE_FIELD_KEYS.filter(
        (key) => overrides?.[key] != null
    ).length;
    if (differentCount === 0) return 'Same as commercial';
    if (differentCount === OVERRIDE_FIELD_KEYS.length) return 'All different from commercial';
    return `${differentCount} different from commercial`;
};
